import { render, staticRenderFns } from "./CreatePostView.vue?vue&type=template&id=f759168e&scoped=true"
import script from "./CreatePostView.vue?vue&type=script&lang=js"
export * from "./CreatePostView.vue?vue&type=script&lang=js"
import style0 from "./CreatePostView.vue?vue&type=style&index=0&id=f759168e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f759168e",
  null
  
)

export default component.exports